<span [class]="'icon icon-' + icon" [style]="style"></span>
